// extracted by mini-css-extract-plugin
module.exports = {"root":"LayoutSettings_root__F4brI","content":"LayoutSettings_content__DV3fu"};